import Cookies from "js-cookie"
import jQBrowser from "jquery.browser"

$(document).ready(function () {

    var test = window.location.href.indexOf('old-browser-test=1') > -1;

    if(Cookies.get('old-browser-checked') && !test) return;


    var browser_version = parseInt(jQBrowser.version.split('.')[0]);

    if (
        (jQBrowser.msie && browser_version < 12)
        ||
        (jQBrowser.mozilla && browser_version < 24)
        ||
        (jQBrowser.chrome && browser_version < 30)
        ||
        (jQBrowser.opera && browser_version < 20)
        ||
        (jQBrowser.safari && browser_version < 7)
        ||
        test
    ) {
        $.get('/general/oldbrowser').done(function (r) {
            if (r) {
                $('body').append(r);
            }
        });
    }


    if(!test){
        Cookies.set('old-browser-checked', '1', { expires: 30, path: '/' })
    }
});